module.exports = __webpack_public_path__ + "img/icon_click.7182f177.svg";